/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Integration_Status_Key_ValidInputs */

const en_ui_integration_status_key_valid = /** @type {(inputs: Ui_Integration_Status_Key_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key valid`)
};

const de_ui_integration_status_key_valid = /** @type {(inputs: Ui_Integration_Status_Key_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Key gültig`)
};

/**
* | output |
* | --- |
* | "Key valid" |
*
* @param {Ui_Integration_Status_Key_ValidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_integration_status_key_valid = /** @type {((inputs?: Ui_Integration_Status_Key_ValidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Integration_Status_Key_ValidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_integration_status_key_valid(inputs)
	return de_ui_integration_status_key_valid(inputs)
});